import { Navigate } from "react-router-dom";
import { usePartnerAuth } from "../../auth/PartnerAuthProvider";
import { usePartnerPortalBase } from "./PartnerPortalBaseProvider";

export default function PartnerWhatsappFeatureGate({ children }) {
  const { partner, loading } = usePartnerAuth();
  const { dashboardPath, portalLoadingLabel } = usePartnerPortalBase();

  if (loading) {
    return <p className="partner-portal-loading muted">{portalLoadingLabel}</p>;
  }

  if (partner?.features?.whatsappMonitoring === false) {
    return <Navigate to={dashboardPath} replace />;
  }

  return children;
}
